import { QueryClient } from "@tanstack/react-query"
import { axiosInstance } from "./axios"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: async ({ queryKey }) => {
        const { data } = await axiosInstance.get(queryKey[0] as string)
        return data
      },

      refetchOnReconnect(query) {
        if (query.state.status === `pending`) {
          return true
        }
        return false
      },
    },
  },
})
